import React, { useEffect, useState } from "react";
import { getStorageItem, setStorageItem } from "../../utils";
import { cn } from "@utils/cn";
import { Text, Button, Icon, Link } from "@ui-component-library";
import { useMetricData } from "../hooks/UseMetricData";

export default function LockedInfoBanner({ className = "" }) {
  const { propDfr } = useMetricData();
  const [hideInfoModal, setHideInfoModal] = useState(false);

  const handleCloseInfoModal = () => {
    setStorageItem("hideInfoModal", true);
    setHideInfoModal(true);
  };

  useEffect(() => {
    const savedHideInfoModal = getStorageItem("hideInfoModal");
    if (savedHideInfoModal) {
      setHideInfoModal(true);
    }
  }, []);

  

  if (hideInfoModal || propDfr) return null;

  return (
    <div className={cn("py-4 px-4 w-full mx-auto mb-4", className)}>
      <div className="flex items-start lg:items-center bg-cloud-200 border border-[#E6E6E6] border-solid rounded-xl p-4 mx-4 justify-between">
        <div className="flex flex-col gap-2 lg:flex-row">
          <div className="flex flex-wrap gap-1">
          <Text variant="text-sm/leading-normal/semibold">
            Vissa detaljer är låsta:
          </Text>
          <Text
            variant="text-sm/leading-normal/normal"
            className="text-charcoal-400"
          >
            Upptäck skogens fulla potential med <b>Treebula Plus</b>
          </Text>
          </div>
          <Link
            href="/min-skog/?view=pricing"
            target="blank"
            underline
          >
            <Text
              variant="text-sm/leading-normal/normal"
              className="text-charcoal-400"
            >
              Läs mer
            </Text>
          </Link>
        </div>

        <Button
          variant="tertiary"
          size="icon"
          onClick={handleCloseInfoModal}
        >
          <Icon name="CrossSimple" size="large" />
        </Button>
      </div>
    </div>
  );
}
